// Polling-day gate shared by the components that switch behaviour when
// counting starts (unofficial-results badges, swing-tile colours, …).
//
// Before voting day — window.countdownTarget (public/config.js) in the future,
// or unset/invalid — returns true. Callers re-render frequently (15s data
// polls), so the flip happens within a poll cycle of the target passing.
export const isBeforeTarget = () => {
  const t =
    typeof window !== 'undefined' && window.countdownTarget
      ? new Date(window.countdownTarget)
      : null;
  if (!t || Number.isNaN(t.getTime())) return true;
  return Date.now() < t.getTime();
};
